import React from 'react';
import { useTheme } from '@mui/material/styles';

import { EmptyExploreImage, NoResultsImage } from 'common/components/image';
import { Button, Stack, Typography } from 'common/components/material';
import { useRouter } from 'common/hooks';
import AppRoutes from 'common/routes/AppRoutes.enum';
import {
  HEADING_TEXT,
  HEADING_TEXT_INVITE_USERS,
  SUBHEADING_TEXT,
  SUBHEADING_TEXT_INVITE_USERS,
} from '../explore.constants';
import { EmptySearchViewProps } from 'features/search';

const EmptySearchView: React.FC<EmptySearchViewProps> = ({
  headerTextElement,
  showInviteUsersButtonView = false,
  showEmptyExploreImage,
}) => {
  const { goTo } = useRouter();
  const { palette } = useTheme();

  return (
    <>
      {headerTextElement}
      <Stack
        alignItems="center"
        justifyContent="center"
        spacing={2}
        style={{
          height: '30em',
        }}
        data-analytics-tag="search_no_results_found"
      >
        {showEmptyExploreImage ? <EmptyExploreImage /> : <NoResultsImage />}
        <Typography variant="h4" color={palette.Text.Headline}>
          {showInviteUsersButtonView ? HEADING_TEXT_INVITE_USERS : HEADING_TEXT}
        </Typography>
        <Typography variant="body1" color={palette.Text.SubHeadline}>
          {showInviteUsersButtonView ? SUBHEADING_TEXT_INVITE_USERS : SUBHEADING_TEXT}
        </Typography>
        {showInviteUsersButtonView && (
          <Button onClick={() => goTo(AppRoutes.ADMIN_INVITE_USERS)} btntype="primary">
            Invite People
          </Button>
        )}
      </Stack>
    </>
  );
};

export default EmptySearchView;
